import React from 'react';

import { PopUp, Dialog, DialogHeader, DialogContent } from '@ergeon/core-components';

import { Agent } from '../../types';
import { type ModalHandler } from '../index';
import { AgentSelectionView } from '../../components/AgentSelection';
import { useModalClose } from '../../hooks/useModalClose';

type Props = {modal: ModalHandler; excludeIdentity: string};

const AgentsListModal: React.FC<Props> = ({ modal, excludeIdentity }) => {
  const closeModal = useModalClose(modal);

  const onSelect = (agent: Agent) => {
    modal.resolve(agent);
    closeModal();
  };

  return (
    <PopUp isVisible={modal.visible} maxWidth="large" onChangeVisible={closeModal}>
      <Dialog isVisible={modal.visible}>
        <DialogHeader onDismiss={closeModal} title="Agents" />
        <DialogContent>
          <AgentSelectionView
            excludeIdentity={excludeIdentity}
            onSelect={onSelect}
            title="Select an agent from the list" />
        </DialogContent>
      </Dialog>
    </PopUp>
  );
};

export default AgentsListModal;
